import React from "react";
import {
    Datagrid, DateField,
    List,
    TextField,
    TextInput,
    SelectInput,
    Filter, ReferenceField, UrlField, SimpleShowLayout, ImageField, BooleanField,
} from "react-admin";
import {ReportFilterStatus, ReportFilterTypes} from "./reportConstant";
import ShowView from "../../components/ShowView";

const ReportFilter = (props) => (
  <Filter {...props}>
    <TextInput label="شناسه" source="objectId"/>
    <TextInput label="شناسه گزارشگر" source="reporterUserId"/>
    <SelectInput
      label="نوع گزارش"
      choices={ReportFilterTypes}
      optionText={"name"}
      optionValue={"value"}
      source={"reportType"}
      alwaysOn
    />
    <SelectInput
      label="حالت گزارش"
      choices={ReportFilterStatus}
      optionText={"name"}
      optionValue={"value"}
      source={"reportStatus"}
      alwaysOn
    />
    <TextInput label="شناسه کاربر گزارش شده" source="reportedUserId"/>
    <TextInput label="شناسه مکالمه گزارش شده" source="conversationId"/>
    <TextInput label=" شناسه پیام گزارش شده" source="messageId"/>
  </Filter>
);


export const ReportList = (props) => (
  <List {...props} filters={<ReportFilter/>} >
    <Datagrid rowClick={"show"}>
      <TextField source="objectId"/>
        <ReferenceField link="show" label="کاربر گزارشگر" source="reporterUserId" reference="user" >
            <TextField source="name"/>
        </ReferenceField>
      <TextField source="reportType"/>
      <DateField showTime={true} locales={"fa-IR"} source="createdAt"/>
      <TextField source="reportStatus"/>
        <ReferenceField link="show" label="کاربر گزارش شده" source="reportedUserId" reference="user" >
            <TextField source="name"/>
        </ReferenceField>
        <ReferenceField link="show" label="مکالمه" source="conversationId" reference="conversation" >
            <TextField source="title"/>
        </ReferenceField>
        <ReferenceField link="show" label="پیام" source="messageId" reference="message" >
            <TextField source="text"/>
        </ReferenceField>
    </Datagrid>
  </List>
);

export const ReportShow = (props) => (
    <ShowView {...props} noDel={true} noEdit={true}>
    <SimpleShowLayout>
        <TextField source="objectId"/>
        <ReferenceField link="show" label="کاربر گزارشگر" source="reporterUserId" reference="user" >
            <TextField source="name"/>
        </ReferenceField>
        <TextField source="reportType"/>
        <DateField showTime={true} locales={"fa-IR"} source="createdAt"/>
        <TextField source="reportStatus"/>
        <ReferenceField link="show" label="کاربر گزارش شده" source="reportedUserId" reference="user" >
            <TextField source="name"/>
        </ReferenceField>
        <ReferenceField link="show" label="مکالمه" source="conversationId" reference="conversation" >
            <TextField source="title"/>
        </ReferenceField>
        <ReferenceField link="show" label="پیام" source="messageId" reference="message" >
            <TextField source="text"/>
        </ReferenceField>
    </SimpleShowLayout>
    </ShowView>
);
